<div class="jeopardy-app">
  <div class="leaderboard-main">
    <div></div>
    <div>
      <div class="leaderboard-header">
        <div>
          <p class="menu-item round-neon" [class.active]="activeTab === 'global'">
            <a href="#" (click)="setActiveTab($event, 'global')">
              <img style="width: 10vh" src="assets/app-branding/img/icons/Icons-GlobalScores.png"
                   alt="{{ i18n.str('challengeu.leaderboard_global_results', 'See global results')() }}" />
            </a>
          </p>
          <h3>{{ i18n.str('challengeu.leaderboard_global', "Global")() }}</h3>
        </div>
        @if (currentUser?.location?.country?.value) {
        <div>
          <p class="menu-item round-neon" [class.active]="activeTab === 'country'">
            <a href="#" (click)="setActiveTab($event, 'country')">
              <img style="width: 10vh" src="assets/app-branding/img/icons/Icons-LocalScores.png"
                   alt="{{ i18n.str('challengeu.leaderboard_country_results', 'See country results')() }}" />
            </a>
          </p>
          <h3>{{ currentUser.location.country.value }}</h3>
        </div>
        }
      </div>
      <ul class="leaderboard-list" style="max-height: 52vh; overflow-y: auto;">
        @for (player of leaderboard; track player.userId; let i = $index) {
        <li [ngClass]="{'jeopardy-box primary': false}">
          <div class="inner">
            <!-- <div class="row"  [class.active]="i === 2"> -->
            <div class="player-place" [class.first-place]="i === 0" [class.second-place]="i === 1"
                 [class.third-place]="i === 2">
              {{ i > 2 ? i+1 : '' }}
            </div>
            <div class="player-points">{{ player.score }}</div>
            <div class="player-details">
              {{player.name}}
              <br>
              {{player.location}}
            </div>
            <div class="user-avatar">
              <img class="avatar" [alt]="i18n.str('challengeu.avatar_picture', 'Your avatar picture')()"
                   src="assets/app-branding/img/avatars/cartoon/{{player.avatar}}" />
            </div>
            <!-- </div> -->
          </div>
        </li>
        }
      </ul>
      <div style="margin-top: 3em;">
        <!-- <p class="jeopardy-button secondary">
        <a href="#">{{ i18n.str('challengeu.leaderboard_share_results', "SHARE RESULTS")() }}</a>
      </p> -->

        <div class="inline-buttons">
          <p class="jeopardy-button primary">
            <a href="#" routerLink="/main-menu">{{ i18n.str('challengeu.leaderboard_play_again', "PLAY AGAIN")() }}</a>
          </p>
          <p class="jeopardy-button secondary">
            <a href="https://www.consilium.europa.eu/" target="_blank">{{ i18n.str('challengeu.leaderboard_know_more',
              "KNOW MORE")() }}</a>
          </p>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</div>
